import { memo } from 'react';

import { getMod } from 'services/hooks';
import { getModComponent } from 'services/utils';

export const TipToastsDisplay = memo(() => {
  const popupTipsModComponents = getMod('popupTips')?.components;

  const TopToastStackMC = getModComponent(
    popupTipsModComponents?.TopToastStack
  );
  const MessagePopupMC = getModComponent(popupTipsModComponents?.MessagePopup);

  return (
    <>
      <TopToastStackMC />
      <MessagePopupMC />
    </>
  );
});
